// libraries
import { useContext, useState } from "react";
import { Link, useParams } from "react-router-dom";

// style
import "../styles/Recipes.css";

// context
import RecipesContext from "../context/recipes";

// assets
// import bg from "../assets/image_3.jpg";

// helpers
import {
  categoryRecipes,
  mealRecipes,
  getCategoryFromLocalStorage,
} from "../utils/helpers";

// components
import { useEffect } from "react";
import Hero from "../components/Hero";
import Loading from "../components/Loading";
import Newsletter from "../components/Newsletter";
import RecommendedRecipesItem from "../components/Home/RecommendedRecipesItem";

const Recipes = ({ fromHome }) => {
  // use context
  const { loading, recipes } = useContext(RecipesContext);

  // use params
  const { id } = useParams();

  // use state
  const [recipeByCategory, setRecipeByCategory] = useState([]);
  const [category, setCategory] = useState(getCategoryFromLocalStorage());
  const [meal, setMeal] = useState("all");
  const [showMealPlan, setShowMealPlan] = useState(id === "mp" ? true : false);

  useEffect(() => {
    setRecipeByCategory(mealRecipes(categoryRecipes(recipes, category), meal));
    return () => {
      localStorage.removeItem("category");
    };
  }, [category, meal, recipes]);

  return (
    <>
      <Hero
        // image={bg}
        title={showMealPlan ? "Meal Plan" : "Recipes"}
        breadName={showMealPlan ? "Meal Plan" : "Recipes"}
        singleProduct={false}
      />
      <section className='py-5'>
        <div className='container'>
          {loading ? (
            <div className='loading-wrapper'>
              <Loading />
            </div>
          ) : !showMealPlan ? (
            <>
              <div className='row justify-content-center'>
                <div className='col-md-10 text-center'>
                  <div className='d-flex align-items-center justify-content-center mb-5'>
                    <button
                      className='btn btn-primary'
                      onClick={() => setShowMealPlan(true)}
                    >
                      Generate Meal Plan
                    </button>
                  </div>
                  <ul className='product-category'>
                    <li>
                      <span
                        onClick={() => setCategory("all")}
                        className={`${category === "all" && "active"}`}
                      >
                        All
                      </span>
                    </li>
                    <li>
                      <span
                        onClick={() => setCategory("vegetarian")}
                        className={`${category === "vegetarian" && "active"}`}
                      >
                        Vegetarian
                      </span>
                    </li>
                    <li>
                      <span
                        onClick={() => setCategory("vegan")}
                        className={`${category === "vegan" && "active"}`}
                      >
                        Vegan
                      </span>
                    </li>
                    <li>
                      <span
                        onClick={() => setCategory("pescatarian")}
                        className={`${category === "pescatarian" && "active"}`}
                      >
                        Pescatarian
                      </span>
                    </li>
                    <li>
                      <span
                        onClick={() => setCategory("keto")}
                        className={`${category === "keto" && "active"}`}
                      >
                        Keto
                      </span>
                    </li>
                    <li>
                      <span
                        onClick={() => setCategory("mediterranean")}
                        className={`${
                          category === "mediterranean" && "active"
                        }`}
                      >
                        Mediterranean
                      </span>
                    </li>
                    <li>
                      <span
                        onClick={() => setCategory("kids")}
                        className={`${category === "kids" && "active"}`}
                      >
                        Kids
                      </span>
                    </li>
                    <li>
                      <span
                        onClick={() => setCategory("healthy")}
                        className={`${category === "healthy" && "active"}`}
                      >
                        Healthy
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className='row justify-content-center mt-3'>
                <div className='col-md-10 mb-5 text-center'>
                  <ul className='product-category'>
                    <li>
                      <span
                        onClick={() => setMeal("all")}
                        className={`${meal === "all" && "active"}`}
                      >
                        All
                      </span>
                    </li>
                    <li>
                      <span
                        onClick={() => setMeal("breakfast")}
                        className={`${meal === "breakfast" && "active"}`}
                      >
                        Breakfast
                      </span>
                    </li>
                    <li>
                      <span
                        onClick={() => setMeal("lunch")}
                        className={`${meal === "lunch" && "active"}`}
                      >
                        Lunch
                      </span>
                    </li>
                    <li>
                      <span
                        onClick={() => setMeal("dinner")}
                        className={`${meal === "dinner" && "active"}`}
                      >
                        Dinner
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className='row'>
                {recipeByCategory.length > 0 ? (
                  recipeByCategory.map((item, index) => {
                    return (
                      <RecommendedRecipesItem
                        key={index}
                        title={item.recipe}
                        id={item.uuid}
                        meal={item.meal}
                        category={item.category}
                        image={item.image}
                        user={item.user}
                      />
                    );
                  })
                ) : (
                  <div className='recipes-empty'>
                    <h5>No recipes to show!</h5>
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className='row d-flex justify-content-center'>
              <Link to='/meal-plan/1' className='btn btn-primary mx-3 w-25'>
                Generate 1 Week Meal Plan
              </Link>
              <Link to='/meal-plan/2' className='btn btn-primary mx-3 w-25'>
                Generate 2 Week Meal Plan
              </Link>
              <div className='col-12 mt-3 text-center'>
                <span
                  className='text-muted'
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowMealPlan(false)}
                >
                  Back
                </span>
              </div>
            </div>
          )}
        </div>
      </section>
      <Newsletter />
    </>
  );
};

export default Recipes;
